// @flow

import {
    GET_FLIGHTS,
    GET_FLIGHTS_SUCCESS,
    GET_FLIGHTS_FAIL,
    DELETE_FLIGHT,
    DELETE_FLIGHT_SUCCESS,
    DELETE_FLIGHT_FAIL,
    EDIT_FLIGHT,
    EDIT_FLIGHT_SUCCESS,
    EDIT_FLIGHT_FAIL,
    ADD_FLIGHT,
    ADD_FLIGHT_SUCCESS,
    ADD_FLIGHT_FAIL,
    CLEAR_FLIGHT_MANAGER_ERROR,
    SELECT_FLIGHT,
    SET_CHOSEN_FLIGHT_BY_ID,
    START_FLIGHT,
    START_FLIGHT_SUCCESS,
    START_FLIGHT_FAIL,
    FINISH_FLIGHT,
    FINISH_FLIGHT_SUCCESS,
    FINISH_FLIGHT_FAIL,
    GET_PRODUCTS,
    GET_PRODUCTS_SUCCESS,
    GET_PRODUCTS_FAIL,
    GET_TIME_ZONES,
    GET_TIME_ZONES_SUCCESS,
    GET_TIME_ZONES_FAIL,
    SET_FLIGHT_GEOMETRY_TYPE,
} from './../types/flightManager';
import type { Flight } from './../hocs/flightManager';


type FlightData = {
    type: string,
    axiosInstance?: Object,
    error?: string,
    data?: any,
};

export const getFlights = (axiosInstance: Object): FlightData =>({
    type: GET_FLIGHTS,
    axiosInstance
});
export const getFlightsSuccess = (rawDataArray: any): FlightData => ({
    type: GET_FLIGHTS_SUCCESS,
    rawDataArray
});
export const getFlightsFail = (error: string): FlightData => ({
    type: GET_FLIGHTS_FAIL,
    error
});

export const deleteFlight = (axiosInstance: Object, id: number): FlightData =>({
    type: DELETE_FLIGHT,
    axiosInstance, 
    id
});
export const deleteFlightSuccess = (id: number): FlightData =>({
    type: DELETE_FLIGHT_SUCCESS,
    id
});
export const deleteFlightFail = (error: string): FlightData =>({
    type: DELETE_FLIGHT_FAIL,
    error
});

export const setFlightGeometryType = (flightGeometryType: string)=>({
    type: SET_FLIGHT_GEOMETRY_TYPE,
    flightGeometryType
});

export const editFlight = (axiosInstance: Object, editedRowData: any): FlightData=>({
    type: EDIT_FLIGHT,
    axiosInstance,
    editedRowData
})
export const editFlightSuccess = (editedRowData: any): FlightData=>({
    type: EDIT_FLIGHT_SUCCESS,
    editedRowData
})
export const editFlightFail = (error: string): FlightData =>({
    type: EDIT_FLIGHT_FAIL,
    error
})

export const addFlight = (axiosInstance: Object, editedRowData: any): FlightData=>({
    type: ADD_FLIGHT,
    axiosInstance,
    editedRowData
})
export const addFlightSuccess = (editedRowData: any): FlightData=>({
    type: ADD_FLIGHT_SUCCESS,
    editedRowData
})
export const addFlightFail = (error: string): FlightData=>({
    type: ADD_FLIGHT_FAIL,
    error
})

export const clearMessage = (): FlightData=>({
    type: CLEAR_FLIGHT_MANAGER_ERROR
})

export const setChosenFlight = (chosenFlight: Flight): FlightData=>({
    type: SELECT_FLIGHT,
    chosenFlight,
})

export const setChosenFlightById = (id: number): FlightData=>({
    type: SET_CHOSEN_FLIGHT_BY_ID,
    id
})

export const startFlight = (axiosInstance: Object, id: number): FlightData=>({
    type: START_FLIGHT,
    axiosInstance,
    id
})
export const startFlightSuccess = (id: any): FlightData=>({
    type: START_FLIGHT_SUCCESS,
    id
})
export const startFlightFail = (error: string): FlightData =>({
    type: START_FLIGHT_FAIL,
    error
});

export const finishFlight = (axiosInstance: Object, id: number): FlightData=>({
    type: FINISH_FLIGHT,
    axiosInstance,
    id
});

export const finishFlightSuccess = (id: any): FlightData=>({
    type: FINISH_FLIGHT_SUCCESS,
    id
});

export const finishFlightFail = (error: string): FlightData =>({
    type: FINISH_FLIGHT_FAIL,
    error
});

export const getProducts = (axiosInstance: Object): FlightData =>({
    type: GET_PRODUCTS,
    axiosInstance
});
export const getProductsSuccess = (rawDataArray: any): FlightData => ({
    type: GET_PRODUCTS_SUCCESS,
    rawDataArray
});
export const getProductsFail = (error: string): FlightData => ({
    type: GET_PRODUCTS_FAIL,
    error
});

export const getTimeZones = (axiosInstance: Object): FlightData =>({
    type: GET_TIME_ZONES,
    axiosInstance
});
export const getTimeZonesSuccess = (rawDataArray: any): FlightData => ({
    type: GET_TIME_ZONES_SUCCESS,
    rawDataArray
});
export const getTimeZonesFail = (error: string): FlightData => ({
    type: GET_TIME_ZONES_FAIL,
    error
});


// WEBPACK FOOTER //
// ./src/actions/flightManager.jsx